import Vue from "vue";
import Vuex from "vuex";
import axios from "../plugins/axios";
import api from "../api";
import { ui } from "./ui";
import vaccount from "./user-vaccounts";

Vue.use(Vuex);

var refreshToken = sessionStorage.getItem("refreshToken");
var accessToken = sessionStorage.getItem("accessToken");

var payload = JSON.parse(atob(accessToken?.split?.(".")?.[1] ?? "") || "{}");
var tokenHeader = JSON.parse(atob(accessToken?.split?.(".")?.[0] ?? "") || "{}");
var scope = payload?.scope || [];
var _cert_MypageExchange = sessionStorage.getItem("_cert_MypageExchange");

const store = new Vuex.Store({
    state: {
        refreshToken,
        accessToken,
        payload,
        tokenHeader,
        scope,
        _cert_MypageExchange,
        user: null,

        recentProducts: [],
        pickupItems: [],
    },
    mutations: {
        login(state, { refreshToken, accessToken }) {
            state.refreshToken = refreshToken;
            state.accessToken = accessToken;

            state.payload = JSON.parse(atob(accessToken?.split(".")[1] || "") || "{}");
            state.scope = state.payload?.scope || [];

            axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

            sessionStorage.setItem("refreshToken", refreshToken);
            sessionStorage.setItem("accessToken", accessToken);
        },

        logout(state) {
            state.refreshToken = undefined;
            state.accessToken = undefined;

            state.payload = {};
            state.scope = [];

            axios.defaults.headers.common["Authorization"] = "";

            sessionStorage.removeItem("refreshToken");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("_cert_MypageExchange");
        },

        set_cert_MypageExchange(state, { _cert }) {
            state._cert_MypageExchange = _cert;
            sessionStorage.setItem("_cert_MypageExchange", _cert);
        },

        setUser(state, { user }) {
            state.user = user;
        },

        recent(state, product) {
            if (!state.recentProducts.find((item) => item._id == product._id)) state.recentProducts.unshift(product);
            if (3 < state.recentProducts.length) state.recentProducts.pop();
        },

        pickup(state, cartItems) {
            state.pickupItems = cartItems;
        },

        checkout(state) {
            state.pickupItems = [];
        },
    },
    actions: {
        async login({ dispatch, commit }, { username, password, ci }) {
            var { refreshToken } = await api.auth.getRefreshToken({ username, password, ci });
            var { accessToken } = await api.auth.getAccessToken(refreshToken);

            commit("login", { refreshToken, accessToken });
            dispatch("getUser");
        },

        async logout({ commit }) {
            // await api.v1.me.logout.delete()
            commit("logout");
        },

        async getUser({ commit }) {
            const { me } = await api.v1.me.profile.get();
            commit("setUser", { user: me });
        },

        async refresh({ commit }, { refreshToken, _cert }) {
            var { accessToken } = await api.auth.getAccessToken(refreshToken, _cert);

            commit("login", { refreshToken, accessToken });
        },

        addToCart({ commit }, _carts) {
            commit("addToCart", _carts);
        },

        pickup({ commit }, { carts }) {
            commit("pickup", carts);

            return Promise.resolve();
        },

        checkout(context) {
            context.commit("checkout");
        },

        recent({ commit }, product) {
            commit("recent", product);
        },
    },
    modules: {
        ui,
        vaccount,
    },
});

Vue.use({
    install: function(Vue, options) {
        Vue.prototype.$scopes = store.state.scope;
        Vue.prototype.$hasScope = (scopes) => {
            return store.state.scope.find((scope) => scopes.includes(scope));
        };
    },
});

export default store;
